import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringRich from "csi/heading/StringRich";
import declare from "dojo/_base/declare";
import _ from "lodash";

const CareBySalesRegionRenderer = declare(StringRich, {
	/**
	 * @override
	 * Display care instructions by language
	 */
	toValue(ctx: Context, h: Heading): string {
		const languageNode = ctx.getNode();
		const careInstructions = ctx.cache.getNodes(ctx.getParent().CareInstructions);

		return careInstructions
			.map((care) => care?.Languages?.[languageNode.SysID] || null)
			.filter(Boolean)
			.join(", ");
	},
});

export = CareBySalesRegionRenderer;